import { useThemeContext } from "@circle-react/providers/Theme/ThemeContext";
import {
  APPEARANCE,
  APPEARANCE_SYSTEM,
  isStoredPreference,
} from "@circle-react/providers/Theme/themes/constants";
import type { StoredAppearancePreference } from "@circle-react/providers/Theme/themes/constants";
import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";

import { DrawerMenuItem } from "./components/DrawerMenuItem";

interface MobileAppearanceDrawerContentProps {
  /** Force-close the entire drawer stack. */
  onClose?: () => void;
}

/**
 * Child drawer content for the Appearance setting.
 */
export const MobileAppearanceDrawerContent = ({
  onClose,
}: MobileAppearanceDrawerContentProps) => {
  const { storedPreference, setAppearance } = useThemeContext();

  const activeOption: StoredAppearancePreference = isStoredPreference(
    storedPreference,
  )
    ? storedPreference
    : "";

  const handleSelect = (value: Exclude<StoredAppearancePreference, "">) => {
    setAppearance?.(value);
    onClose?.();
  };

  const activeTrailing = <Icon name="checkmark" size="md" />;

  return (
    <div className="flex flex-col gap-0.5">
      <DrawerMenuItem
        icon="sun"
        label={t("mobile_shell.appearance_light")}
        onClick={() => handleSelect(APPEARANCE.LIGHT)}
        trailing={
          activeOption === APPEARANCE.LIGHT ? activeTrailing : undefined
        }
      />
      <DrawerMenuItem
        icon="moon"
        label={t("mobile_shell.appearance_dark")}
        onClick={() => handleSelect(APPEARANCE.DARK)}
        trailing={activeOption === APPEARANCE.DARK ? activeTrailing : undefined}
      />
      <DrawerMenuItem
        icon="phone"
        label={t("mobile_shell.appearance_system")}
        onClick={() => handleSelect(APPEARANCE_SYSTEM)}
        trailing={
          activeOption === APPEARANCE_SYSTEM ? activeTrailing : undefined
        }
      />
    </div>
  );
};
